import { IFeedbackModal } from 'components/layout/FeedbackModal';
import { SUPPORT_EMAIL } from 'constants/info';

export const RESPONSE_CODE = {
  // error data.code === 'email-unauthorized'
  EMAIL_UNAUTHORIZED: 'EMAIL_UNAUTHORIZED',
  ERROR: 'ERROR',
} as const;

export type TResponseCodeValues =
  (typeof RESPONSE_CODE)[keyof typeof RESPONSE_CODE];

export const REGISTER_FEEDBACK = {
  [RESPONSE_CODE.EMAIL_UNAUTHORIZED]: {
    type: 'error',
    title: 'Invalid email',
    message: `The email is invalid. If you think this is a mistake, please contact the support team at ${SUPPORT_EMAIL}`,
  },
  [RESPONSE_CODE.ERROR]: {
    type: 'error',
    title: 'SignUp Error',
    message: 'Please try again later',
  },
} as const;

export const AWAITING_VALIDATION_FEEDBACK: IFeedbackModal = {
  type: 'warning',
  title: 'Account validation pending',
  message:
    'Your account is pending validation. You will be notified once the process is complete.',
};

// Login modal tabs
export const TAB_VALUE = {
  LOGIN: 0,
  REGISTER: 1,
} as const;

export type TTabValue = (typeof TAB_VALUE)[keyof typeof TAB_VALUE];
